import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var DiamondFilledIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M15.775 4c1.029 0 1.922.583 2.648 1.255l.152.145 3.503 3.693a3 3 0 01-.146 3.78l-.132.141-7.68 7.68-.036-.036-.055.12-.094.084-.096.08a3 3 0 01-3.818-.114l-.144-.135-7.679-7.68a3 3 0 01-.39-3.763l.112-.158L5.475 5.4c.377-.406.734-.772 1.198-1.012.42-.216.882-.347 1.361-.38L8.275 4h7.5z",
                        fillRule: "evenodd"
                    })
                })
            })
        ]
    });
};
DiamondFilledIcon.isCarinaIcon = true;
export default DiamondFilledIcon;
